"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var numberUtils_1 = require("spry-react/utils/numberUtils");
function getCurrencyFragment(value) {
    var stringValue = numberUtils_1.formatCurrency(Math.abs(value));
    var currencyParts = stringValue.split('.');
    return (React.createElement(React.Fragment, null,
        value < 0 ? React.createElement("span", null, "(") : null,
        React.createElement("span", null, currencyParts[0]),
        currencyParts.length > 1
            ? React.createElement("sup", null, currencyParts[1])
            : null,
        value < 0 ? React.createElement("span", null, ")") : null));
}
exports.getCurrencyFragment = getCurrencyFragment;
